module.exports = __webpack_public_path__ + "static/img/far2.58a57164.png";